"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var ARROWS_POSITION = {
  ON_GALLERY: 0,
  OUTSIDE_GALLERY: 1
};
var _default = ARROWS_POSITION;
exports["default"] = _default;